<template>
  <div class="zyzbody">
    <div class="container list">
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-xs-12 card"
          v-for="(doc,index) in docs"
          :key="doc.title"
        >
          <h4>{{index+1}}</h4>
          <img style="width:100%" :src="doc.imgurl" />
          <!-- <img style="width:100%" :src="imgUrl+doc.title+'?token='+token" /> -->
          <div>【标题】：{{doc.title}}</div>
          <div>【分类】：{{doc.category}}</div>
          <div>【时间】：{{doc.updatetime}}</div>
          <div>
            【简介】：
            <span v-html="doc.intro.replace(/<img/g,'<img class=img-fluid')"></span>
          </div>
          <div class="cut">
            【xflink】：
            <ul>
              <li v-for="(link,indexL) in doc.xfurl" :key="link">
                <a :href="link" target="_blank">{{indexL+1}}.{{link}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Zyzbody',
  props: ['docs','imgUrl','token']
};
</script>
<style scoped>
div.cut {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>